(function () {
  // Code to catch tooltip clicks so they do not close the ajax cart drawer
  let trapActive = false;

  const qOpen = 'tool-tip[data-tool-tip-open="true"]';
  const qInner = '[data-tool-tip-inner]';
  const qClose = '[data-tool-tip-close]';

  function closeTooltip(tip) {
    if (!tip) return;
    if (typeof tip.close === 'function') { tip.close(); return; }
    if (typeof tip.hide === 'function')  { tip.hide(); return; }
    tip.removeAttribute('data-tool-tip-open');
    tip.classList.remove('is-open', 'open', 'active');
  }

  function interceptClick(e) {
    const tip = document.querySelector(qOpen);
    if (!tip) return;

    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    if (e.target.closest(qClose)) { closeTooltip(tip); return; }
    if (e.target.closest(qInner)) return;

    closeTooltip(tip);
  }

  function enableTrap() {
    if (trapActive) return;
    trapActive = true;
    document.addEventListener('click', interceptClick, true);
  }

  function disableTrap() {
    if (!trapActive) return;
    trapActive = false;
    document.removeEventListener('click', interceptClick, true);
  }

  const mo = new MutationObserver(function () {
    if (document.querySelector(qOpen)) {
      enableTrap();
    } else {
      disableTrap();
    }
  });

  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-tool-tip-open']
  });
})();

(function () {
  const OPEN_DELAY = 180;
  const CLOSE_DELAY = 220;
  const SPEED_LIMIT = 0.9;
  const REST_WINDOW = 80;

  const menuItems = document.querySelectorAll('.site-nav__item.site-nav--has-dropdown');
  if (!menuItems.length) return;

  let lastMove = { x: 0, y: 0, t: 0 };
  let moves = [];

  function onMove(e) {
    const now = performance.now();
    lastMove = { x: e.clientX, y: e.clientY, t: now };
    moves.push(lastMove);
    while (moves.length && (now - moves[0].t) > 300) moves.shift();
  }

  window.addEventListener('mousemove', onMove, { passive: true });

  function downwardSpeed() {
    if (moves.length < 2) return 0;
    const a = moves[moves.length - 2];
    const b = moves[moves.length - 1];
    const dy = b.y - a.y;
    const dt = Math.max(1, b.t - a.t);
    return dy / dt;
  }

  function movingToward(rect) {
    const p = lastMove;
    return (p.x >= rect.left && p.x <= rect.right && p.y <= rect.top + 20);
  }

  menuItems.forEach(function (item) {
    const link = item.querySelector('.site-nav__link');
    const dropdown = item.querySelector('.site-nav__dropdown');

    let openTimer = null;
    let closeTimer = null;
    let enteredAt = 0;

    function open() {
      item.classList.add('is-open');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function close() {
      item.classList.remove('is-open');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    function clearTimers() {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    item.addEventListener('mouseenter', function () {
      enteredAt = performance.now();
      clearTimers();
      if (downwardSpeed() > SPEED_LIMIT) return;

      openTimer = setTimeout(function () {
        const rested = performance.now() - enteredAt >= REST_WINDOW;
        if (rested) open();
      }, OPEN_DELAY);
    });

    item.addEventListener('mouseleave', function () {
      clearTimers();
      if (dropdown) {
        const rect = dropdown.getBoundingClientRect();
        if (movingToward(rect)) {
          closeTimer = setTimeout(close, CLOSE_DELAY);
          return;
        }
      }
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    if (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        clearTimers();
        open();
      });
      dropdown.addEventListener('mouseleave', function () {
        clearTimers();
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });
    }

    if (link) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      link.addEventListener('focus', function () {
        clearTimers();
        open();
      });
      link.addEventListener('blur', function () {
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });

      const prefersHover = window.matchMedia('(hover: hover)').matches;
      let armedForNavigate = false;

      link.addEventListener('click', function (e) {
        if (!dropdown) return;

        if (prefersHover) return;

        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          open();
          armedForNavigate = true;
        } else if (armedForNavigate) {
          armedForNavigate = false;
        }
      });
    }
  });
})();
